import { strapi } from "@strapi/client";

import { env } from "@/env";

export const strapiClient = strapi({
	baseURL: `${env.VITE_STRAPI_BASE_URL}/api`,
	auth: env.VITE_STRAPI_API_TOKEN,
});

export const articlesCollection = strapiClient.collection("articles");
export const investorAnnouncementsCollection = strapiClient.collection(
	"investor-announcements",
);
